/*
    https://github.com/Kagami/ffmpeg.js/pull/149
    for build need use emcc 2.0.9
    branch https://github.com/erisco/ffmpeg.js
 */

const FFMPEG = 'https://www.eyespy360.com/library/ffmpeg/ffmpeg-worker-mp4.js';
const FFMPEG_FILTERES = 'https://www.eyespy360.com/library/ffmpeg-worker-mp4_filters.js';

export const loadFFMPEG = (workerPath) => {
    return new Promise(async(res, rej) => {
        try{
            var blob = URL.createObjectURL(new Blob(['importScripts("' + workerPath + '")'], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            URL.revokeObjectURL(blob);
            res(worker);
        }catch (e){
            rej(e);
        }
    })
}

const getBuffer = function (file) {
    return new Promise((req, rej) => {
        try{
            var fr = new FileReader();
            fr.onload = function(e) {
                req(new Uint8Array(e.target.result));
            };
            fr.readAsArrayBuffer(file);
        }catch (e) {
            console.error(e);
            rej();
        }
    })
}

export const repeatMp3 = (audio, count, duration) => {
    return new Promise(async (res, rej) => {
        try{
            const buffer = await getBuffer(audio);
            const worker = await loadFFMPEG(FFMPEG_FILTERES);

            worker.onmessage = function(e) {
                const msg = e.data;
                switch (msg.type) {
                    case "ready":
                        worker.postMessage({
                            type: "run",
                            MEMFS: [{name: 'background_audio.mp3', data: buffer}],
                            arguments: [
                                '-i',
                                'background_audio.mp3',
                                '-af',
                                `atrim=0:duration=${duration},aloop=${count}:size=44100*${duration}`,
                                `output.mp3`,
                            ]
                        });
                        break;
                    case "stdout":
                        console.log(msg.data);
                        break;
                    case "stderr":
                        console.log(msg.data);
                        break;
                    case "done":
                        console.log(msg.data);
                        res(new Blob([msg.data.MEMFS[0].data], {type: 'audio/mp3'}));
                        break;
                }
            }
        }catch (e){
            rej(e)
        }
    })
}

export const cutMp3 = (audio, start, duration) => {
    return new Promise(async (res, rej) => {
        try{
            const buffer = await getBuffer(audio);
            const worker = await loadFFMPEG(FFMPEG_FILTERES);
            const commands = `-i background_audio.mp3 -ss ${start} -t ${duration} -c copy output.mp4`;
            worker.onmessage = function(e) {
                const msg = e.data;
                switch (msg.type) {
                    case "ready":
                        worker.postMessage({
                            type: "run",
                            MEMFS: [{name: 'background_audio.mp3', data: buffer}],
                            arguments: commands.split(' ')
                        });
                        break;
                    case "stdout":
                        console.log(msg.data);
                        break;
                    case "stderr":
                        console.log(msg.data);
                        break;
                    case "done":
                        console.log(msg.data);
                        res(new Blob([msg.data.MEMFS[0].data], {type: 'audio/mp3'}));
                        break;
                }
            }
        }catch (e){
            rej(e)
        }
    })
}
